export const validImage = (files: FileList, size: number, extensions: string[] = ["jpe?g", "png"]): boolean =>
  !files.length ||
  (new RegExp(`\\.(${extensions.join("|")})$`, "i").test(files[0].name) && files[0].size / 1024 / 1024 <= size);

export const isEmail = (val: string): boolean => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(val);

export const isValidPassword = (val: string): boolean =>
  // eslint-disable-next-line no-useless-escape
  /^[A-Z0-9-!@#$%^&*()_+|~=`{}\[\]:\\";'<>?,.\/]{6,12}$/i.test(val);

export const isValidName = (val: string): boolean =>
  /^[\u4e00-\u9fa5\uE7C7-\uE7F3\u0800-\u4e00A-Za-z-_.\s]*$/i.test(val);

export const isValidTaxId = (val: string): boolean => /^\d{8}$/i.test(val);

export const isValidPhone = (val: string): boolean => /^\d*$/i.test(val);
